<script setup>
import useApprovalTable from "./hooks/useApprovalTable";
import { APPROVAL_TYPE, TAG_TYPE } from "@/constants";
import { onMounted, ref } from "vue";
import ApprovalDialog from "./approvalDialog.vue";
import ApprovalDetail from "./approvalDetail.vue";
import useUserList from "../hooks/useUserList";
import { queryDictList } from "@/api/dict";
import { DICT_KEY } from "@/constants/dict";

const { userList } = useUserList();

const {
  searchRef,
  searchData,
  columns,
  tableLoading,
  tableData,
  menuList,
  activeIndex,
  pages,
  changeCategory,
  handleSizeChange,
  handleCurrentChange,
  indexMethod,
  approvalRef,
  countObj,
  countToMenu,
  approvalDetailRef,
  getList,
  handleReset,
  handleExport,
  handleMenuSelect,
  handleSubmitApproval,
  handleDetail,
  handleRest,
} = useApprovalTable();

const PROCESS_STATUS = [
  {
    label: "审核中",
    value: "2",
  },
  {
    label: "审核通过",
    value: "3",
  },
  {
    label: "审核不通过",
    value: "4",
  },
];

const typeList = ref([]); // 物料用途
const inStorageTypeList = ref([]); // 入库类型

onMounted(() => {
  getList();
  queryDictList(DICT_KEY["boundAcceptMaterial"]).then((res) => {
    typeList.value = res.data || [];
  });
  queryDictList(DICT_KEY["boundTypeIn"]).then((res) => {
    inStorageTypeList.value = res.data || [];
  });
});
</script>

<template>
  <zh-table-page v-bind="{ title: '审核管理' }">
    <template #header-btn></template>
    <template #search>
      <el-form :model="searchData" ref="searchRef" :inline="true">
        <el-form-item label="审批类型：" prop="category">
          <el-select
            filterable
            clearable
            v-model="searchData.category"
            placeholder="请选择"
            style="width: 150px"
            @change="changeCategory"
          >
            <el-option
              v-for="item in APPROVAL_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="业务类型："
          prop="type"
          v-if="searchData.category === '1'"
        >
          <el-select
            filterable
            clearable
            v-model="searchData.type"
            placeholder="请选择"
            style="width: 150px"
          >
            <el-option
              v-for="item in inStorageTypeList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="业务类型："
          prop="type"
          v-if="searchData.category === '7'"
        >
          <el-select
            filterable
            clearable
            v-model="searchData.type"
            placeholder="请选择"
            style="width: 150px"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.dictLabel"
              :value="String(item.dictValue)"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="审批状态：" prop="processStatus">
          <el-select
            filterable
            clearable
            v-model="searchData.processStatus"
            placeholder="请选择"
            style="width: 150px"
          >
            <el-option
              v-for="item in PROCESS_STATUS"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="创建人：" prop="createBy">
          <el-select
            v-model="searchData.createBy"
            placeholder="请选择"
            style="width: 150px"
            clearable
            filterable
          >
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.nikeName"
              :value="item.userCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="Search" @click="getList()"
            >查询</el-button
          >
          <el-button icon="Refresh" @click="handleReset()">重置</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template #table>
      <el-menu
        :default-active="activeIndex"
        mode="horizontal"
        @select="handleMenuSelect"
      >
        <el-menu-item
          v-for="item in menuList"
          :key="item.index"
          :index="item.index"
          >{{ item.label }}({{
            countObj[countToMenu[item.index]]
          }})</el-menu-item
        >
      </el-menu>
      <!-- 表格 -->
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{
          'text-align': 'center',
        }"
        style="width: 100%; margin-top: 10px"
        max-height="650"
        v-loading="tableLoading"
        :data="tableData"
      >
        <el-table-column
          label="序号"
          type="index"
          width="55"
          :index="indexMethod"
        />
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <span v-if="[, 'category'].includes(item.prop)">{{
                row[item.prop].desc
              }}</span>
              <el-tag
                v-else-if="item.prop == 'processStatus'"
                :type="TAG_TYPE[row[item.prop]?.value]"
                >{{ row[item.prop].desc }}</el-tag
              >
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="180" fixed="right">
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              @click="handleSubmitApproval(row)"
              v-if="row.processStatus.value == 2 && activeIndex != 'processed'"
              >审核</el-button
            >
            <el-button type="primary" link @click="handleDetail(row)"
              >详情</el-button
            >
            <el-button
              v-if="
                activeIndex == 'processed' &&
                row.category?.value == 1 &&
                row.processStatus?.value == 3
              "
              type="primary"
              link
              @click="handleRest(row)"
              >撤销审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="pages.total > 0"
        background
        style="margin-top: 10px"
        :current-page="pages.page"
        :page-size="pages.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="pages.total"
        layout="->, total, prev, pager, next, sizes, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </template>
  </zh-table-page>
  <!-- 审核弹窗 -->
  <approval-dialog ref="approvalRef" @after-approval="getList" />

  <!-- 审核详情弹窗 -->
  <approval-detail ref="approvalDetailRef" />
</template>

<style scoped></style>
